var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.carregado)?_c('div',{staticClass:"home"},[_c('NavBar'),_c('v-container',{staticClass:"fill-height pa-0 container-limited",attrs:{"fluid":""}},[_c('v-row',{class:_vm.$vuetify.breakpoint.name !== 'xs'
            ? 'ma-0 s-pa-n6 s-pb-n5'
            : 'ma-0 s-pa-n4 s-pt-n4',attrs:{"id":"infos-aluno"}},[_c('DadosAluno'),_c('ResumoAluno')],1),_c('ResultadoAnalise')],1)],1):(_vm.erro)?_c('div',[_c('NotFound')],1):_c('div',[_c('Loading')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }